/**
 * Sorts array elements by its weight. Biggest weight comes first
 * @example
 * ```ts
 * [5,2,9,1,5,6].sort(createSortHandler(n => [n])) // [9,6,5,5,2,1]
 * [[0,11],[1,10],[0,5]].sort(createSortHandler(n => [n[0], n[1]])) // [[1,10],[0,11],[0,5]]
 * ```
 */
export const createSortHandler = <T extends any>(weightsExtractor: (a: T) => number[]) => {
  const cache = new Map<T, number[]>()
  return (a: T, b: T) => {
    if (!cache.has(a)) cache.set(a, weightsExtractor(a))
    if (!cache.has(b)) cache.set(b, weightsExtractor(b))

    const ak = cache.get(a)!
    const bk = cache.get(b)!

    for (let i = 0; i < ak.length; i++) {
      const p1 = ak[i]
      const p2 = bk[i]
      const r = p2 - p1
      if (r !== 0) return r
    }

    return 0
  }
}
